import { render, staticRenderFns } from "./servicecard.vue?vue&type=template&id=0bdeae25&scoped=true&"
import script from "./servicecard.vue?vue&type=script&lang=js&"
export * from "./servicecard.vue?vue&type=script&lang=js&"
import style0 from "./servicecard.vue?vue&type=style&index=0&id=0bdeae25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdeae25",
  null
  
)

export default component.exports